var ageVerified = document.cookie
  .split("; ")
  .find((row) => row.startsWith("age-verified"));

if (!ageVerified) {
  setTimeout(() => {
    document.querySelector("#age-verify-modal").style.display = "flex";
    document.body.style.overflow = "hidden";
  }, 5000);
}

document.querySelector("#yes-btn").addEventListener("click", () => {
  document.querySelector("#age-verify-modal").style.display = "none";
  const has_verify = document.getElementById("block-product");
  if(has_verify == null){
    document.body.style.overflow = "auto";
  }
  // Send data of modal to Google Analytics
  ga("send", "event", "age-verify", "modal", "yes");

  //cookies expire after 48 hours
  var date = new Date();
  date.setTime(date.getTime() + 48 * 60 * 60 * 1000);
  var expires = "; expires=" + date.toUTCString();
  document.cookie = "age-verified=true" + expires + "; path=/";
});

document.querySelector("#no-btn").addEventListener("click", () => {
  window.location.href = "/pages/restriction-age";
});
